<template>
  <section>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex row w100 middle">
          <div>
            <tabs :data="reportTabs" v-model="currentTab" :disable="checkHaveCampaign" :disableMsg="disableMsg" :key="currentTab"></tabs>
          </div>
          <div class="flex-1 flex end">
            <div class="flex column no-mobile" style="margin-right: 14px;">
              <label>Atualizar dados</label>
              <div class="flex end w100" style="margin-top:14px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>
            <div class="filter-item">
              <label>Tracking: </label>
              <select class="input" v-model="filters.data.track">
                <option v-for="(c, index) in filters.list.listTrack" :key="index" :value="c.value" :selected="c.value === filters.data.track">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="filter-item">
              <label>Ordenar por: </label>
              <select class="input" v-model="filters.data.order_by">
                <option v-for="(c, index) in filters.list.listOrderBy" :key="index" :value="c.value" :selected="c.value === filters.data.order_by">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="filter-item">
              <label>Ordenação: </label>
              <select class="input" v-model="filters.data.order">
                <option v-for="(c, index) in filters.list.listOrder" :key="index" :value="c.value" :selected="c.value === filters.data.order">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>
    </section>
    <!-- account -->
    <account 
      v-if="currentTab === 'account'" 
      :filters="filters"
      :accountsFilter="accountSelecteds"
      @accountSelected="addAccount($event)"
      @accountRemoved="removeAccount($event)"
      @cleanAccountSelect="cleanAccount($event)"
    ></account>
    <!-- campaign -->
    <campaign 
      v-if="currentTab === 'campaign'" 
      :filters="filters"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      @campaignSelected="addCampaign($event)"
      @campaignRemoved="removeCampaign($event)"
      @cleanCampaignSelect="cleanCampaign($event)"
    ></campaign>
    <!-- adgroup -->
    <ad-group 
      v-if="currentTab === 'adgroup'" 
      :filters="filters"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
      @adgSelected="addAdg($event)"
      @adgRemoved="removeAdg($event)"
      @cleanAdgSelect="cleanAdg($event)"
    >
    </ad-group>
    <!-- ad -->
    <ad 
      v-if="currentTab === 'ad'"
      :filters="filters"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
    ></ad>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import Account from "./Account";
import Campaign from "./Campaign";
import AdGroup from "./AdGroup";
import Ad from "./Ad";

import moment from "moment";
moment.locale("pt-br");

export default {
  name: "campaign-dash",
  components: {
    Tabs,
    Account,
    Campaign,
    AdGroup,
    Ad,
    ltkDatePicker,
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      accountSelecteds: [],
      campaignsSelecteds: [],
      adGroupSelecteds: [],
      disableMsg: "Você precisa selecionar pelo menos uma campanha!",
      filters: {
        data: {
          refresh: false,
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          order: 'desc',
          order_by: 'status',
          track: 'LAST_PV'
        },
        list: {
          listOrderBy: [
            {
              value: 'status',
              label: 'Ativas'
            },
            {
              value: 'id',
              label: 'Data de Criação'
            },
            {
              value: 'spend',
              label: 'Valor Gasto'
            },
            {
              value: 'sales',
              label: 'Vendas (FBADS / GADS)'
            },
            {
              value: 'sales_lh',
              label: 'Vendas LH'
            },
            {
              value: 'sales_cost',
              label: 'CPA (FBADS / GADS)'
            },
            {
              value: 'sales_lh_cost',
              label: 'CPA LH'
            },
            {
              value: 'roas_lh',
              label: 'ROAS LH'
            },
            {
              value: 'conversion',
              label: 'Conversão (FBADS / GADS)'
            },
            {
              value: 'conversion_lh',
              label: 'Conversão LH'
            }
          ],
          listTrack: [
            {
              value: 'FIRST_PV',
              label: 'Primeiro Clique'
            },
            {
              value: 'LAST_PV',
              label: 'Último Clique'
            },
          ],
          listOrder: [
            {
              value: 'desc',
              label: 'Do Maior para o Menor'
            },
            {
              value: 'asc',
              label: 'Do Menor para o Maior'
            },
          ]
        },
      },
      currentTab: "campaign",
      
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }
  },
  computed: {
    // FIXME: AJUSTAR ISSO PARA SELECIONAR ACCOUNT
    checkHaveCampaign() {
      return false

      // if (this.campaignsSelecteds.length > 0) { 
      //   return false
      // }

      // if (this.currentTab == 'campaign') {
      //   return false
      // }

      // return true
    },
    reportTabs() {
      let account = 'Conta de Anúncio'
      if (this.accountSelecteds.length > 0) {
        account = `${account} (${this.accountSelecteds.length})`
      }

      let campaigns = 'Campanhas'
      if (this.campaignsSelecteds.length > 0) {
        campaigns = `${campaigns} (${this.campaignsSelecteds.length})`
      }

      let adgroup = 'Conjuntos de Anúncios'
      if (this.adGroupSelecteds.length > 0) {
        adgroup = `${adgroup} (${this.adGroupSelecteds.length})`
      }

      return [
          {
            name: "account",
            title: account,
          },
          {
            name: "campaign",
            title: campaigns,
          },
          {
            name: "adgroup",
            title: adgroup,
          },
          {
            name: "ad",
            title: "Anúncios",
          },
        ]
      },
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      } 
    },
    currentTab(value) {
      if (this.slug === value) {
        return
      }

      this.$router.push({ name: "CampaignDash", params: { slug: this.currentTab } });
    }
  },
  methods: {
    forceRefreshData() {
      this.filters.data.refresh = !this.filters.data.refresh 
    },
    addAccount(accountId) {
      this.accountSelecteds.push(accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeAccount(accountId) {
      this.accountSelecteds = this.accountSelecteds.filter( e => e !== accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanAccount() {
      this.accountSelecteds = []
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    addCampaign(campId) {
      this.campaignsSelecteds.push(campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeCampaign(campId) {
      this.campaignsSelecteds = this.campaignsSelecteds.filter( e => e !== campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanCampaign() {
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    cleanAdg() {
      this.adGroupSelecteds = []
    },
    addAdg(adgId) {
      this.adGroupSelecteds.push(adgId)
    },
    removeAdg(adgId) {
      this.adGroupSelecteds = this.adGroupSelecteds.filter( e => e !== adgId)
    },
  },

};
</script>

<style lang="scss" scoped>
.filter-item {
  max-width: 200px;
  .input {
    min-width: 100px;
  }
}
</style>
